import { render, staticRenderFns } from "./vsCollapse.vue?vue&type=template&id=612664fc&"
import script from "./vsCollapse.vue?vue&type=script&lang=js&"
export * from "./vsCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsCollapse.vue"
export default component.exports